import { noop } from 'lodash';
import { createContext } from 'utilsTS/react';

export interface StackContextType {
    stacks: Record<string, string[]>;
    toggle: (key: string, id: string, active: boolean) => void;
    get: (key: string) => string[];
}

export const StackContext = createContext<StackContextType>('Stack', {
    stacks: {},
    toggle: noop,
    get: () => [],
});
